// extracted by mini-css-extract-plugin
export default {"form":"text-edit-form_form__-jCL5","titleContainer":"text-edit-form_titleContainer__qUnMo","content":"text-edit-form_content__H8aQx"};